/**
 * 模版市场-企业升级提示
 * @author VenDream
 * @since 17/11/13
 */

import React from 'react';
import PropTypes from 'prop-types';
export default function OrgUpdateTips(props) {
  const { isOpenOrgTip, handleOrgUpdate, handleGoOrgService } = props;

  // 开通企业专区提示
  const renderOpenOrgZoneTip = () => {
    return (
      <div className="open-tip-container">
        <div className="imgs">
          <span className="img-tips">暂未开通企业模板管理功能</span>
        </div>
        <div className="upgrade-tips">
          <span className="text-tips">请开通会员后进行使用</span>
          <span className="upgrade-btn" onClick={handleGoOrgService}>
            立即申请
          </span>
        </div>
      </div>
    );
  };

  // 申请企业专区提示
  const renderApplyOrgZoneTip = () => {
    return (
      <div className="apply-tip-container">
        <div className="imgs">
          <span className="img-tips">企业模板内部创建</span>
          <span className="img-tips">企业模板与素材库共享</span>
          <span className="img-tips">大数据传播分析</span>
        </div>
        <div className="upgrade-tips">
          <span className="original-price">原价: 1999</span>
          <span className="upgrade-btn" onClick={handleOrgUpdate}>
            免费申请
          </span>
        </div>
      </div>
    );
  };

  return (
    <div className="org-upgrade-tips">
      {isOpenOrgTip ? renderOpenOrgZoneTip() : renderApplyOrgZoneTip()}
    </div>
  );
}

OrgUpdateTips.propTypes = {
  handleOrgUpdate: PropTypes.func,
  handleGoOrgService: PropTypes.func,
  isOpenOrgTip: PropTypes.bool,
};
